module.exports = __webpack_public_path__ + "static/img/jindou.4ae0b469.png";